import React from 'react';
import Dropzone from 'react-dropzone';
import './FormDocument.css';
import uploadSvg from 'images/upload.svg';
import DocumentLink from 'components/shared/document/DocumentLink';
import removeSvg from 'images/remove.svg';

/**
 * Wrapper for Document piciker field used inside redux-form.
 * @param props
 * @return {*}
 * @constructor
 */
export default function FormDocument(props) {
  if (props.input.value === '') {
    const isValid = !props.meta.error || !props.meta.submitFailed;
    return (
      <div className="form-document">
        <Dropzone
          accept="application/pdf, .doc, .docx, .xls, .xlsx"
          className={`dropzone-container${!isValid ? ' with-error' : ''}`}
          multiple={false}
          onDrop={(files) => props.input.onChange(files[0])}
        >
          <span>Please drag and drop any file into this area</span>
          <img src={uploadSvg} alt="upload" />
        </Dropzone>
      </div>
    );
  }
  const documentLinkProps = {};
  if (props.input.value.hasOwnProperty('url')) {
    documentLinkProps.url = props.input.value.url;
  } else {
    documentLinkProps.file = props.input.value;
  }
  return (
    <div className="form-document">
      <div className="file-viewer">
        <DocumentLink showIcon={false} {...documentLinkProps} />
        <img
          src={removeSvg}
          alt="remove"
          onClick={() => props.input.onChange('')}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/shared/form/FormDocument.js